__turbopack_context__.v({
  "className": "lato_e44718c7-module__I7-BeG__className",
  "variable": "lato_e44718c7-module__I7-BeG__variable",
});
